import { type DialogProps, Slide, type SlideProps } from '@mui/material';
import { Dialog, useIsMobile } from '@side/pantry';

const SlideUp = (props: SlideProps) => <Slide direction="up" {...props} />;

export function FiltersDialog({ children, ...props }: DialogProps) {
  const isMobile = useIsMobile();

  return (
    <Dialog
      slots={{
        transition: isMobile ? SlideUp : undefined,
      }}
      slotProps={{
        paper: {
          sx: {
            overflowY: 'visible',
            maxHeight: { xs: 'none', md: '80%' },
            // MUI sets -webkit-overflow-scrolling on DialogContent for iOS < 13
            // momentum scrolling. WebKit promotes that scroller to its own
            // stacking context, which traps the filters' disablePortal
            // Autocomplete poppers underneath the dialog actions once the
            // on-screen keyboard shrinks the viewport enough for them to overlap.
            '& .MuiDialogContent-root': { WebkitOverflowScrolling: 'auto' },
          },
        },
      }}
      {...props}
    >
      {children}
    </Dialog>
  );
}
